module.exports = __webpack_public_path__ + "static/dutchie-e82312becb3cfc83b0cfecd85ab50410.png";